import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import "./AppNavBar.css";

import {
  AppBar,
  Container,
  Toolbar,
  Typography,
  Button
} from "@mui/material";
// import { styled } from "@mui/material/styles";
import { useEffect, useState } from "react";

// const LogoutButton = styled(LogoutIcon)`
//   &.MuiButton-contained {
//     background-color: #fff !important;
//     color: #121212 !important;
//     font-weight: 600 !important;
//     font-size: 14px !important;
//     text-transform: none !important;
//     border-radius: 6px !important;
//     box-shadow: none !important;
//     margin-right: 20px;
//   }
//   &:hover {
//     background-color: #f3f4f6 !important;
//   }
// `;

export default function AppNavBar() {
  const [title, setTitle] = useState("");

  const { userToken, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isLoginPage = location.pathname.includes("login");
    setTitle(isLoginPage ? "VENDOR REGISTRATION" : "PURCHASE ORDER");
  }, [location.pathname]);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const isLoggedIn = Boolean(userToken);

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>

          <Link className="logo-container" to="/">
            <img
              className="logo"
              src={`${process.env.PUBLIC_URL}/images/plugin-logo.png`}
              alt="logo"
            />
          </Link>

          <Typography
            variant="h6"
            noWrap
            sx={{
              flexGrow: 1,
              fontFamily: "sans-serif",
              fontWeight: 700,
              color: "#fff",
              textAlign: "center",
              marginLeft: "-90px",
            }}
          >
            {title}
          </Typography>

          {isLoggedIn && (
            <button className="Btn" onClick={handleLogout}>
              <div className="sign">
                <svg viewBox="0 0 512 512">
                  <path d="M377.9 105.9L500.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L377.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1-128 0c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM160 96L96 96c-17.7 0-32 14.3-32 32l0 256c0 17.7 14.3 32 32 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-53 0-96-43-96-96L0 128C0 75 43 32 96 32l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32z"></path>
                </svg>
              </div>

              <div className="text">Logout</div>
            </button>
          )}
        </Toolbar>
      </Container>
    </AppBar>
  );
}
